import { render } from "./ConsoleOptions.vue?vue&type=template&id=65239b01&scoped=true"
import script from "./ConsoleOptions.vue?vue&type=script&lang=js"
export * from "./ConsoleOptions.vue?vue&type=script&lang=js"

import "./ConsoleOptions.vue?vue&type=style&index=0&id=65239b01&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65239b01"]])

export default __exports__